import React from 'react'

const PartnerNav = ({onClick}) => {
  return (
    <>
      <p className="text-sm">
        Sebagian partner tidak ditemukan? <span className="link" onClick={onClick}>Klik disini untuk menambah secara manual</span>
      </p>
    </>
  )
}

export { PartnerNav }
